<div class="box">
	@if (loading) {
		<mat-progress-bar mode="indeterminate"></mat-progress-bar>
	}
	<form [formGroup]="formGroups.f0Header">
		<div class="header">
			@if (!addMode) {
				<mat-form-field id="id" appearance="outline">
					<mat-label>{{ _lang("id") }}</mat-label>
					<input formControlName="origId" matInput />
				</mat-form-field>
			}
			<mat-form-field id="requestTitle" appearance="outline">
				<mat-label>{{ _lang("requestTitle") }}</mat-label>
				<input matInput formControlName="requestTitle" />
			</mat-form-field>
			<mat-form-field id="commitmentStart" appearance="outline">
				<mat-label>{{ _lang("commitmentStart") }}</mat-label>
				<input
					matInput
					formControlName="commitmentStart"
					(dateChange)="updateNumberOfPersonDays()"
					[max]="formGroups.f0Header.controls.commitmentEnd.value"
					[matDatepicker]="periodStartPicker"
				/>
				<mat-datepicker-toggle matSuffix [for]="periodStartPicker"></mat-datepicker-toggle>
				<mat-datepicker #periodStartPicker></mat-datepicker>
			</mat-form-field>
			<mat-form-field id="commitmentEnd" matTooltip=" {{ _lang('commitmentEnd') }} ">
				<mat-label>{{ _lang("commitmentEnd") }}</mat-label>
				<input
					matInput
					formControlName="commitmentEnd"
					(dateChange)="updateNumberOfPersonDays()"
					[min]="formGroups.f0Header.controls.commitmentStart.value"
					[matDatepicker]="periodEndPicker"
				/>
				<mat-datepicker-toggle matSuffix [for]="periodEndPicker"></mat-datepicker-toggle>
				<mat-datepicker #periodEndPicker></mat-datepicker>
			</mat-form-field>
			@if (permissions.hasReadOnConfidentialFields) {
				<mat-form-field id="probability" appearance="outline">
					<mat-label>
						{{ _lang("probability") }}
					</mat-label>
					<mat-select formControlName="probability">
						@for (option of options.probability; track option) {
							<mat-option id="select-option-{{ option.value }}" [value]="option.value">
								{{ option.viewValue | translate }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			}
			<mat-form-field id="request_type" appearance="outline">
				<mat-label>
					{{ _lang("request_type") }}
				</mat-label>
				<mat-select formControlName="requestType" (selectionChange)="checkIfBannerNeeded($event.value)">
					@for (option of options.requestType; track option) {
						<mat-option
							id="select-option-{{ option.value }}"
							[value]="option.value"
							[disabled]="disabled || currentUserIsMA"
						>
							{{ option.viewValue | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<mat-form-field id="status" appearance="outline">
				<mat-label>{{ _lang("status") }}</mat-label>
				<mat-select
					formControlName="requestStatus"
					(openedChange)="$event && infoPopupStatus ? infoPopupStatus.open() : infoPopupStatus.close()"
					panelClass="mat-select-max-height-unset"
				>
					<div
						id="popupStatus"
						#infoPopupStatus="mepPopover"
						[mepPopover]="infoPopupStatusValue"
						[mepPopoverConfig]="{trigger: 'manual', placement: 'left-start', popoverClass: 'ngb-popover-border'}"
					></div>
					@for (option of options.status; track option) {
						<mat-option id="select-option-{{ option.value }}" [value]="option.value">
							{{ option.viewValue | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<ng-template #infoPopupStatusValue>
				<div id="infoPopupStatus">
					<h3>
						<b>{{ _lang("status") }}</b>
					</h3>
					<table>
						@for (option of options.status; track option) {
							<tr>
								<td id="popupStatusKey">{{ option.viewValue | translate }}</td>
								<td>
									{{ "mep.components.staffing-request-status-tooltip." + option.value.toLowerCase() | translate }}
								</td>
							</tr>
						}
					</table>
				</div>
			</ng-template>
			@if (addMode) {
				<div class="keep-resource-request-ifo">
					<mat-checkbox
						id="keep-resource-request-ifo"
						(change)="toggleResourceRequestSaveMode()"
						[checked]="isMultiResourceRequestSafeMode"
						matTooltip="{{ _lang('keepResourceRequestDataTooltip') }}"
					>
					</mat-checkbox>
					<span class="checkbox-text">
						{{ _lang("keepResourceRequestData") }}
					</span>
				</div>
			}

			<div
				class="animation-fields"
				[@fieldsPopUpAnimation]="
					formGroups.f0Header.controls.requestStatus.value === 'FOLLOW_UP' ? 'visible' : 'hidden'
				"
			>
				@if (formGroups.f0Header.controls.requestStatus.value === "FOLLOW_UP") {
					<mat-form-field id="resubmissionUntil" appearance="outline">
						<mat-label>{{ _lang("resubmissionUntil") }}</mat-label>
						<input
							[matDatepicker]="pickerAnswer"
							[matTooltip]="_lang('statusChange')"
							formControlName="resubmissionDate"
							matInput
						/>
						<mat-datepicker-toggle [for]="pickerAnswer" [matTooltip]="_lang('statusChange')" matSuffix>
						</mat-datepicker-toggle>
						<mat-datepicker #pickerAnswer></mat-datepicker>
					</mat-form-field>
				}
			</div>
			<div class="animation-fields" [@fieldsPopUpAnimation]="isStatusCommentVisible ? 'visible' : 'hidden'">
				@if (isStatusCommentVisible) {
					<mat-form-field id="statusComment" appearance="outline">
						<mat-label>{{ _lang("statusComment") }}</mat-label>
						<textarea formControlName="statusComment" matInput></textarea>
					</mat-form-field>
				}
			</div>
			@if (!addMode) {
				<div
					id="infoPopupImg"
					[disablePopover]="disabled"
					[mepPopover]="infoPopup"
					popoverClass="ngb-popover-border"
					class="mep-info-icon"
				>
					<mat-icon class="pointer">info</mat-icon>
				</div>
			}
			<ng-template #infoPopup>
				<div id="infoPopup">
					<h3>
						<b>{{ _lang("History") }}</b>
					</h3>
					<table class="table">
						<tr>
							<td>{{ _lang("createdAt") }}</td>
							<td>{{ resourceRequest.createdAt | date: "dd.MM.yyyy" }}</td>
							<td>{{ resourceRequest.createdBy }}</td>
						</tr>
						<tr>
							<td>{{ _lang("lastEditedAt") }}</td>
							<td>{{ resourceRequest.lastModifiedAt | date: "dd.MM.yyyy" }}</td>
							<td>{{ resourceRequest.lastModifiedBy }}</td>
						</tr>
						<tr>
							<td>{{ _lang("finishedAt") }}</td>
							<td>{{ resourceRequest.finishingDate | date: "dd.MM.yyyy" }}</td>
						</tr>
					</table>
				</div>
			</ng-template>
		</div>
	</form>

	<div class="header-buttons-spacer">
		<div class="header-buttons">
			@if (addMode && staffingAutofillEnabled) {
				<div>
					<button
						class="mep-btn-small mep-loc-button-width mephisto-autofill"
						[matTooltip]="_lang('mephisto-autofill-tooltip')"
						(click)="openDialogForUploadToMephisto()"
					>
						{{ _lang("mephisto-autofill") }}
						<mat-icon class="mep-btn-small-icon"> auto_fix_high</mat-icon>
					</button>
				</div>
			}

			@if (!hasReadOnlyRole || addMode) {
				<form [formGroup]="formGroups.f0Header">
					<div class="checkbox-dispoFlag">
						<mat-checkbox
							[disabled]="disabled"
							formControlName="dispoFlag"
							matTooltip="{{ _lang('dispoFlagTooltip') }}"
						>
						</mat-checkbox>
						<span class="dispoFlag-Text">
							{{ _lang("dispoFlag") }}
						</span>
					</div>
				</form>
			}

			@if (showFavoriteButton) {
				<button
					matTooltip="{{ _lang('favorite-button-tooltip') }}"
					class="mep-btn-small mep-loc-button-width"
					(click)="markAsFavorite()"
				>
					<mat-icon
						[ngClass]="isFavoriteResourceRequestOfUser ? 'unfillable' : 'not-fill'"
						class="material-symbols-rounded mep-btn-small-icon bigger-favorite-star"
					>
						star
					</mat-icon>
				</button>
			}
			@if (resourceRequest) {
				<div>
					<button
						(click)="shareStaffing()"
						[matTooltip]="_lang('share-staffing-tooltip')"
						class="mep-btn-small mep-loc-button-width"
						disableRipple
					>
						<mat-icon class="mep-btn-small-icon"> share</mat-icon>
					</button>
				</div>
			}
			@if (!addMode && !hasReadOnlyRole) {
				<div class="header-buttons">
					@if (!currentUserIsMA) {
						<button
							class="mep-btn-small mep-loc-button-width"
							[disabled]="disabled || hasReadOnlyRole"
							(click)="copyResourceRequest()"
						>
							<mat-icon class="mep-btn-small-icon">copy</mat-icon>
							{{ _lang("copy") }}
						</button>
					}
					@if (chatBotEnabled) {
						<button
							class="mep-btn-small mep-loc-button-width"
							[disabled]="disabled"
							(click)="askMephisto()"
							matTooltip="{{ _lang('ask-mephisto-tooltip') }}"
						>
							<mat-icon class="mep-btn-small-icon">question_mark</mat-icon>
							{{ _lang("ask-mephisto") }}
						</button>
					}
					<button class="mep-btn-small mep-loc-button-width" (click)="onStaffingCommentsAdd()" [disabled]="disabled">
						<mat-icon class="mep-btn-small-icon">comment</mat-icon>
						{{ _lang("addStaffingComment") }}
					</button>
					@if (!isTypeTask) {
						<button
							class="mep-btn-small mep-loc-button-width"
							[disabled]="disabled"
							(click)="convertToProject()"
							[matTooltip]="_lang('convert-to-project-tooltip')"
						>
							<mat-icon class="mep-btn-small-icon">wifi_protected_setup</mat-icon>
							{{ _lang("convert-to-project") }}
						</button>
					}
					<button
						id="delete-btn"
						*appRequiresPermission="'DELETE_MY'; entity: 'RESOURCE_REQUEST'"
						class="mep-btn-small mep-loc-button-width"
						(click)="deleteResourceRequest()"
						[disabled]="disabled || !permissions.isAdmin"
					>
						<mat-icon class="mep-btn-small-icon">delete</mat-icon>
					</button>
				</div>
			}
		</div>
	</div>
	<mat-horizontal-stepper #stepper [linear]="addMode" labelPosition="bottom" class="stepper-center">
		<ng-template matStepperIcon="edit" let-index="index" let-active="active">
			<div class="step-icon" [ngClass]="{inactive: active}">{{ index + 1 }}</div>
		</ng-template>

		<ng-template matStepperIcon="done" let-index="index" let-active="active">
			<div class="step-icon" [ngClass]="{inactive: active}">{{ index + 1 }}</div>
		</ng-template>

		<mat-step [stepControl]="formGroups.f1CustomerData" label="{{ _lang('customerData') }}">
			<form [formGroup]="formGroups.f1CustomerData" (keydown.enter)="preventDefault($event)">
				<div>
					<div class="rows">
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("client") }}</mat-label>
							<input [matAutocomplete]="acC" formControlName="client" matInput [maxlength]="255" />
							<mat-autocomplete #acC="matAutocomplete">
								@for (option of autocomplete.client.filtered | async; track option) {
									<mat-option [value]="option" id="autocomplete-option-{{ option }}">
										{{ option }}
									</mat-option>
								}
							</mat-autocomplete>
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("project") }}</mat-label>
							<input
								#currentProject
								[matAutocomplete]="acP.matAutocomplete"
								formControlName="currentProject"
								matInput
							/>
							<app-project-autocomplete #acP [inputElement]="currentProject" [onlyMyBU]="true">
							</app-project-autocomplete>
						</mat-form-field>
						@if (!isTypeTask) {
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("offer") }}</mat-label>
								<input matInput formControlName="offer" [maxlength]="128" matTooltip="{{ _lang('offer-reference') }}" />
							</mat-form-field>
						}
						<div class="row">
							<div class="col">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>{{ _lang("countryOfStaffing") }}</mat-label>
									<mat-select multiple formControlName="countryOfStaffing">
										@for (option of options.countryOfStaffing; track option) {
											<mat-option id="select-option-{{ option.value }}" [value]="option.value">
												{{ option.viewValue | translate }}
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>{{ _lang("requiredLanguage") }}</mat-label>
									<mat-select formControlName="requiredLanguage" multiple="true">
										@for (option of options.requiredLanguage; track option) {
											<mat-option id="select-option-{{ option.value }}" [value]="option.value">
												{{ option.viewValue | translate }}
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
						</div>
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("role") }}</mat-label>
							<input matInput formControlName="role" [maxlength]="128" />
						</mat-form-field>
						@if (!(permissions.hasInterestedBUWritePermissionsOnly || hasReadOnlyRole || currentUserIsMA)) {
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("notes") }}{{ "  &#x1F511;  " }}</mat-label>
								<textarea formControlName="notes" matInput class="notes"></textarea>
							</mat-form-field>
						}
						@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
							<mat-checkbox formControlName="optionOnFollowUpBusiness">
								<mat-label>{{ _lang("optionOnFollowUpBusiness") }}{{ "  &#x1F511;  " }}</mat-label>
							</mat-checkbox>
						}
					</div>
					<div class="rows">
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("skillDescription") }}</mat-label>
							<textarea formControlName="skillDescriptionOfCustomer" matInput class="skill-description"> </textarea>
						</mat-form-field>
						<app-redesign-skill-filter
							(skillsChanged)="onUpdateSkills($event)"
							[initialData]="onSkillsLoad"
							[disabled]="disabled || formGroups.f1CustomerData.controls.internalSkillset.disabled"
							[hardChipWidth]="false"
							[preselectedSkills]="selectedSkills"
						></app-redesign-skill-filter>
						<div id="capa-button-row">
							@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
								<mat-form-field id="desiredCandidate" appearance="outline">
									<mat-label>{{ _lang("desiredCandidate") }}{{ "  &#x1F511;  " }}</mat-label>
									<input
										#desiredCandidate
										formControlName="desiredCandidate"
										matInput
										[matAutocomplete]="acDC.matAutocomplete"
									/>
									<app-employee-autocomplete #acDC [inputElement]="desiredCandidate" [asString]="true">
									</app-employee-autocomplete>
								</mat-form-field>
							}
							@if (!isTypeTask) {
								<mat-form-field id="requiredEmployees" appearance="outline" [matTooltip]="_lang('requiredEmployees')">
									<mat-label>{{ _lang("requiredEmployees") }}</mat-label>
									<input
										matInput
										appOnlyInteger
										type="number"
										formControlName="requiredEmployees"
										(change)="updateNumberOfPersonDays()"
										[min]="1"
									/>
								</mat-form-field>
							}
							@if (!isTypeTask) {
								<button
									id="text-extraction-button"
									mat-flat-button
									class="local-button"
									type="button"
									[disabled]="
										disabled ||
										this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value.length === 0 ||
										this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.dirty
									"
									[matTooltip]="_lang('textExtractionTooltip')"
									(click)="extractMEPSkillsFromDescription()"
								>
									<mat-icon>flip</mat-icon>
									{{ _lang("textExtraction") }}
								</button>
							}

							<!--
                          <button
                            (click)="extractMEPSkillsFromDescription()"
                            conditional: permissions.showExperimentalMEPTextextraction
															[disabled]="
																disabled ||
																this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value.length === 0 ||
																this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.dirty
															"

                            [matTooltip]="_lang('textExtractionMepLocalTooltip')"
                            class="local-button"
                            style="border: none; border-radius: 5px"
                            type="button"
                            >
                            <mat-icon>flip</mat-icon>
                            {{ _lang("textExtractionMepLocal") }}
                          </button>
                          -->

							@if (!hasReadOnlyRole && !isTypeTask) {
								<button
									id="capa-button"
									type="button"
									mat-flat-button
									class="local-button center-icon-only-button"
									[disabled]="loading"
									[matTooltip]="_lang('goToKapa')"
									(click)="gotoCapacityOverview()"
								>
									<mat-icon svgIcon="mep_graphic"></mat-icon>
								</button>
							}
							@if (!hasReadOnlyRole && !isTypeTask) {
								<button
									id="instance-wide-button"
									type="button"
									mat-flat-button
									class="local-button center-icon-only-button"
									[disabled]="loading"
									[matTooltip]="_lang('goToInstanceWide')"
									(click)="goToInstanceWideSearch()"
								>
									<mat-icon svgIcon="mep_world"></mat-icon>
								</button>
							}
						</div>
						<app-list-picker
							id="assetPicker"
							[originalList]="listEmitters.files.asObservable()"
							(add)="onAssetAdd()"
							(delete)="onAssetDelete($event)"
							[map]="mapAssets"
							(toggleChange)="onAssetsToggleChange($event)"
							[disabled]="disabled || (!isOwnerOfRR && currentUserIsMA)"
							[addButtonTooltip]="_lang('addAsset')"
							[title]="_lang('assets')"
							[toggleTitle]="_lang('toggleTitle')"
							[toggleTooltip]="_lang('visible-overall-toggleTooltip')"
							[addKeyIconToLabel]="true"
							[toggleText]="_lang('visible-overall-toggleTooltip')"
							height="1.5"
						>
						</app-list-picker>
					</div>
				</div>
			</form>
			<footer>
				<button id="stepper-next-to-p2" mat-flat-button matStepperNext>
					<mat-icon class="arrows"> keyboard_arrow_right</mat-icon>
				</button>
			</footer>
		</mat-step>
		<mat-step [stepControl]="formGroups.f2FrameData" label="{{ _lang('frameData') }}">
			<form [formGroup]="formGroups.f2FrameData">
				@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
					<mat-label class="mep-header-medium-primary">
						{{ _lang("contact") }}
					</mat-label>
				}
				@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
					<div>
						<div class="rows">
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("requestingUnit") }}{{ "  &#x1F511;  " }}</mat-label>
								<input [matAutocomplete]="acRU" formControlName="requestingUnit" matInput [maxlength]="255" />
								<mat-autocomplete #acRU="matAutocomplete">
									@for (option of autocomplete.requestingUnit.filtered | async; track option) {
										<mat-option [value]="option" id="autocomplete-option-{{ option }}">
											{{ option }}
										</mat-option>
									}
								</mat-autocomplete>
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("requestedFrom") }}{{ "  &#x1F511;  " }}</mat-label>
								<input
									#requestedFrom
									formControlName="requestedFrom"
									matInput
									[matAutocomplete]="acE.matAutocomplete"
								/>
								<app-employee-autocomplete #acE [inputElement]="requestedFrom"></app-employee-autocomplete>
								@if (formGroups.f2FrameData.controls.requestedFrom.errors?.invalidEmployee) {
									<mat-error>
										{{ _lang("chooseEmployee") }}
									</mat-error>
								}
							</mat-form-field>
						</div>
						<div class="rows">
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("requestedBy") }}{{ "  &#x1F511;  " }}</mat-label>
								<input #inputElement [matAutocomplete]="acRB.matAutocomplete" formControlName="requestedBy" matInput />
								<app-employee-autocomplete #acRB [inputElement]="inputElement" [asString]="true">
								</app-employee-autocomplete>
							</mat-form-field>
						</div>
					</div>
				}
				@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
					<mat-label class="mep-header-medium-primary">
						{{ _lang("commercial") }}
					</mat-label>
				}
				@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
					<div>
						<div class="rows">
							<mat-form-field appearance="outline" subscriptSizing="dynamic">
								<mat-label>{{ _lang("compensation") }}{{ "  &#x1F511;  " }}</mat-label>
								<input appCommaDecimalPattern formControlName="compensation" matInput />
								<mat-error>
									<strong>{{ "mep.components.add-resource-request.compensation-value-validation" | translate }}</strong>
								</mat-error>
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("ratesDetails") }}{{ "  &#x1F511;  " }}</mat-label>
								<input formControlName="ratesDetails" [maxlength]="1024" matInput />
							</mat-form-field>
						</div>
						<div class="rows">
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("currency") }}{{ "  &#x1F511;  " }}</mat-label>
								<mat-select [value]="100" placeholder="currency" formControlName="currency">
									@for (option of options.currency; track option) {
										<mat-option id="select-option-{{ option.value }}" [value]="option.value">
											{{ option.viewValue | translate }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>{{ _lang("travelExpensePolicy") }}{{ "  &#x1F511;  " }}</mat-label>
								<input formControlName="travelExpensePolicy" matInput [maxlength]="255" />
							</mat-form-field>
						</div>
					</div>
				}
				<mat-label class="mep-header-medium-primary">
					{{ _lang("deploymentModalities") }}
				</mat-label>
				<div>
					<div class="rows">
						<mat-form-field>
							<mat-label>{{ _lang("scope") }}</mat-label>
							<input
								(change)="updateNumberOfPersonDays()"
								[min]="0"
								[max]="100"
								appOnlyInteger
								type="number"
								matInput
								formControlName="scope"
								matTooltip="{{ _lang('scopeInfo') }}"
							/>
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("totalscopePD") }}</mat-label>
							<input appOnlyInteger type="number" formControlName="totalScope" matInput />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("travelMode") }}</mat-label>
							<mat-select [value]="100" placeholder="travelMode" formControlName="travelMode">
								@for (option of options.travelMode; track option) {
									<mat-option id="select-option-{{ option.value }}" [value]="option.value">
										{{ option.viewValue | translate }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
					<div class="rows">
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("scopeComment") }}</mat-label>
							<input formControlName="scopeComment" matInput />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("location") }}</mat-label>
							<input formControlName="location" [maxlength]="255" matInput />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>{{ _lang("travelModeDetails") }}</mat-label>
							<input formControlName="travelModeDetails" matInput />
						</mat-form-field>
					</div>
				</div>
			</form>
			<footer>
				<button id="stepper-prev-to-p1" mat-flat-button matStepperPrevious>
					<mat-icon class="arrows"> keyboard_arrow_left</mat-icon>
				</button>
				<button id="stepper-next-to-p3" mat-flat-button matStepperNext>
					<mat-icon class="arrows"> keyboard_arrow_right</mat-icon>
				</button>
			</footer>
		</mat-step>
		<mat-step [stepControl]="formGroups.f3InternalHistory" label="{{ _lang('internalHistory') }}">
			<form [formGroup]="formGroups.f3InternalHistory">
				<div>
					<div class="rows">
						<div class="row">
							<div class="col">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>{{ _lang("requestReceipt") }}</mat-label>
									<input formControlName="requestReceipt" matInput [matDatepicker]="requestReceiptPicker" />
									<mat-datepicker-toggle matSuffix [for]="requestReceiptPicker"></mat-datepicker-toggle>
									<mat-datepicker #requestReceiptPicker></mat-datepicker>
								</mat-form-field>
							</div>

							<div class="col">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>{{ _lang("answerUntil") }}</mat-label>
									<input
										formControlName="answerUntil"
										matInput
										[matDatepicker]="answerUntilPicker"
										[required]="!departmentCustomizing.isMsgServices"
									/>
									<mat-datepicker-toggle matSuffix [for]="answerUntilPicker"></mat-datepicker-toggle>
									<mat-datepicker #answerUntilPicker></mat-datepicker>
								</mat-form-field>
							</div>
						</div>

						<mat-form-field matTooltip="{{ 'mep.components.add-resource-request.tag-tooltip' | translate }}">
							<mat-label>{{ "mep.components.add-resource-request.staffingTags" | translate }}</mat-label>
							<mat-chip-grid
								#chipList
								[disabled]="disabled || formGroups.f3InternalHistory.controls.staffingTag.disabled"
							>
								@for (chip of lists.staffingTags; track chip) {
									<mat-chip-row
										class="mep-chip"
										(removed)="deleteStaffingTag(chip)"
										[disabled]="disabled || formGroups.f3InternalHistory.controls.staffingTag.disabled"
									>
										{{ chip }}
										<mat-icon matChipRemove>close</mat-icon>
									</mat-chip-row>
								}
								<input
									#staffingTagInput
									formControlName="staffingTag"
									placeholder="{{ 'mep.components.resource-request-list.new-staffingTag' | translate }}"
									[matChipInputFor]="chipList"
									[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
									[matAutocomplete]="acST"
									[disabled]="disabled || formGroups.f3InternalHistory.controls.staffingTag.disabled"
									(matChipInputTokenEnd)="addStaffingTag($event.value, staffingTagInput)"
									(blur)="addStaffingTag(staffingTagInput.value, staffingTagInput)"
								/>
								<mat-autocomplete
									#acST="matAutocomplete"
									autoActiveFirstOption
									(optionSelected)="selected($event.option.viewValue, staffingTagInput)"
								>
									@for (option of autocomplete.staffingTag.filtered | async; track option) {
										<div>
											@if (!lists.staffingTags.includes(option)) {
												<mat-option
													[value]="option"
													id="autocomplete-option-{{ option }}"
													(mousedown)="$event.preventDefault()"
												>
													{{ option }}
												</mat-option>
											}
										</div>
									}
								</mat-autocomplete>
							</mat-chip-grid>
						</mat-form-field>

						<!-- Commented out, data still needed for migration
                              <mat-form-field
                                conditional: departmentCustomizing.isGBP
                                appearance="outline"
                                >
                                <mat-label>{{_lang('responsibleRO')}}</mat-label>
                                <input
                                  #responsibleRO
                                  formControlName="responsibleRO"
                                  matInput
                                  [matAutocomplete]="acRR.matAutocomplete"
                                  >
                                  <app-employee-autocomplete
                                    #acRR
                                    [inputElement]="responsibleRO"
                                    >
                                  </app-employee-autocomplete>
                                </mat-form-field>

                                -->
					</div>
					<div class="rows aggregated-employee-view">
						@if (permissions.hasReadOnConfidentialFields && !isTypeTask) {
							<app-list-picker
						id="offered-employees-list-picker"
						(delete)="onOfferDelete($event)"
						(statusChange)="onOfferedStatusChange($event)"
						(profileViewClick)="openEmployeeFilesViewDialog($event)"
						(transferToProjectClick)="onTransferToProject($event)"
						[map]="mapOffers"
						[possibleSelection]="offeredEmployeeStatusSelection"
						[selectionTranslate]="'mep.components.list-picker.offered-employee-status.'"
						[profilePicture]="offerFindProfilePicture"
						[showProfileViewButton]="showProfileViewButton()"
						[profileViewButtonTooltip]="_lang('view-profiles')"
						[sortOff]="true"
								[originalList]="sortOfferListByStatusAndLastName(listEmitters.offers.asObservable())"
								[filter]="
									filterColumnByValue('status', [
										offeredEmployeeStatus.PROFILE_SHORTLIST,
										offeredEmployeeStatus.PROFILE_ACCEPTED_BY_CUSTOMER,
									])
								"
								[title]="_lang('positiveStatusOfferedEmployees')"
								[disabled]="disabled"
								[showSkillsOfEmployee]="true"
								[removeAddButton]="true"
								[addKeyIconToLabel]="true"
								[showTransferToProjectButton]="formGroups.f1CustomerData.controls.currentProject.value !== null"
								[transferToProjectButtonText]="_lang('transfer-to-project-button')"
								[transferToProjectButtonTooltip]="getTransferToProjectTooltip"
								height="4"
							>
							</app-list-picker>
						}
					</div>
				</div>

				@if (!businessUnitFieldsRefresh) {
					<div class="row" id="second-row">
						<div class="col-2">
							<div class="row">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>{{ _lang("responsibleBusinessUnit") }}</mat-label>
									<mat-select
										formControlName="responsibleBusinessUnit"
										(selectionChange)="updateInterestedFields($event)"
									>
										@if (options?.responsibleBusinessUnitDropDown) {
											<mat-option>
												<app-select-search
													[list]="options.responsibleBusinessUnitDropDown"
													(filtered)="onSearchSelectFiltered('responsibleBusinessUnitDropDown', $event)"
												>
												</app-select-search>
											</mat-option>
										}
										@for (option of filteredOptions.responsibleBusinessUnitDropDown; track option) {
											<mat-option
												id="select-option-{{ option.value }}"
												[value]="option.value"
												[disabled]="!businessUnitsOfUser.includes(option.value)"
											>
												{{ option.viewValue | translate }}
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
							<div class="row">
								<mat-form-field appearance="outline" class="smaller-form-field">
									<mat-label>{{ _lang("responsible") }}</mat-label>
									<input
										#responsibleDE
										formControlName="responsibleDE"
										matInput
										[matAutocomplete]="acRD.matAutocomplete"
									/>
									<app-employee-autocomplete #acRD [inputElement]="responsibleDE"></app-employee-autocomplete>
								</mat-form-field>
								<button
									[disabled]="formGroups.f3InternalHistory.controls.responsibleDE.value === '-'"
									(click)="openMailDialogGlobal()"
									class="resource-mail-button mep-btn-small"
									matTooltip="{{ _lang('staffing-request-notification') }}"
								>
									<mat-icon class="mep-btn-small-icon">email</mat-icon>
								</button>
							</div>
							<div class="row">
								<mat-form-field appearance="outline">
									<mat-label>{{ _lang("divisions") }}</mat-label>
									<mat-select [multiple]="true" placeholder="divisions" formControlName="divisions">
										@for (option of options.division; track option) {
											<mat-option id="select-option-{{ option.value }}" [value]="option.value">
												{{ option.viewValue | translate }}
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
							@if (!businessUnitFieldsRefresh) {
								<div class="row">
									<mat-form-field appearance="outline">
										<mat-label>{{ _lang("interestedBusinessUnits") }}</mat-label>
										<mat-select [multiple]="true" formControlName="businessUnits">
											@if (options?.businessUnit) {
												<mat-option>
													<app-select-search
														[list]="options.businessUnit"
														(filtered)="onSearchSelectFiltered('businessUnit', $event)"
													></app-select-search>
												</mat-option>
											}
											@for (option of filteredOptions.businessUnit; track option) {
												<mat-option
													id="select-option-{{ option.value }}"
													[disabled]="
														!businessUnitsOfUser.includes(option.value) &&
														permissions.hasInterestedBUWritePermissionsOnly
													"
													[value]="option.value"
												>
													{{ option.viewValue | translate }}
												</mat-option>
											}
										</mat-select>
									</mat-form-field>
								</div>
							}
						</div>
						<div class="col-6">
							@if (permissions.hasReadOnConfidentialFields || (isTypeTask && currentUserIsMA)) {
								<app-list-picker
									id="staffingComments"
									(add)="onStaffingCommentsAdd()"
									(delete)="onStaffingCommentsDelete($event)"
									[map]="mapStaffingComments"
									[originalList]="listEmitters.staffingComments.asObservable()"
									[addButtonTooltip]="_lang('addStaffingComment')"
									[title]="_lang('staffingComments')"
									[disabled]="disabled || noEditingAfterResponsibleChange"
									[height]="'3.2'"
									[addKeyIconToLabel]="true"
								>
								</app-list-picker>
							}
						</div>
						<div class="col-4 padding-right-side">
							@if (resourceRequest && permissions.hasReadOnConfidentialFields && !isTypeTask) {
								<app-list-picker
									id="offered-employees-list-picker"
							(add)="onOfferAdd(this.formGroups.f3InternalHistory.value.responsibleBusinessUnit)"
							(delete)="onOfferDelete($event)"
							(statusChange)="onOfferedStatusChange($event)"
							(profileViewClick)="openEmployeeFilesViewDialog($event)"
							[map]="mapOffers"
									[filter]="
										filterColumnByValue('secondColumn', marketUnit.MarketUnit[resourceRequest.responsibleBusinessUnit])
									"
									[possibleSelection]="offeredEmployeeStatusSelection"
							[selectionTranslate]="'mep.components.list-picker.offered-employee-status.'"
							[profilePicture]="offerFindProfilePicture"
							[showProfileViewButton]="showProfileViewButton()"
							[profileViewButtonTooltip]="_lang('view-profiles')"
							[sortOff]="true"
									[originalList]="sortOfferListByStatusAndLastName(listEmitters.offers.asObservable())"
									[addButtonTooltip]="_lang('addEmployee')"
									[title]="_lang('offeredEmployees')"
									[disabled]="disabled || noEditingAfterResponsibleChange"
									[showSkillsOfEmployee]="true"
									[height]="'3.2'"
									[addKeyIconToLabel]="true"
								>
								</app-list-picker>
							}
						</div>
					</div>
				}

				@if (permissions.isAdmin && resourceRequest && !addMode) {
					<div class="row">
						@if (resourceRequest.businessUnits.length > 0) {
							<div class="header-container">
								<h1>{{ _lang("interestedBusinessUnits") }}</h1>
							</div>
						}
						@for (bu of resourceRequest.businessUnits; track bu) {
							<div>
								@if (resourceRequest.responsibleBusinessUnit !== bu) {
									<div>
										<fieldset class="rounded p-3 mb-3 interested-bu-fieldset-row">
											<legend class="legend-interested-bu">{{ marketUnit.MarketUnit[bu] }}</legend>
											<div class="row interested-rows-as-responsible">
												<div class="col-3">
													<app-list-picker
														(add)="onInterestedResponsibleAdd(bu)"
														(delete)="onInterestedResponsibleDelete($event)"
														[map]="mapInterestedResponsible"
														[profilePicture]="offerFindProfilePicture"
														[originalList]="
															filterInterestedResponsibleListByBu(listEmitters.interestedResponsible.asObservable(), bu)
														"
														[title]="_lang('contact-persons')"
														[addButtonTooltip]="_lang('addInterestedResponsible')"
														[addKeyIconToLabel]="true"
														[disabled]="disabled || noEditingAfterResponsibleChange"
														height="2"
													>
													</app-list-picker>
												</div>
												<div class="col-5">
													<app-list-picker
														(add)="onInterestedStaffingCommentAdd(bu)"
														(delete)="onInterestedStaffingCommentsDelete($event)"
														[map]="mapStaffingComments"
														[originalList]="
															filterCommentListByBu(listEmitters.interestedStaffingComments.asObservable(), bu)
														"
														[addButtonTooltip]="_lang('addStaffingComment')"
														[title]="_lang('staffingComments')"
														[addKeyIconToLabel]="true"
														[disabled]="
															disabled ||
															noEditingAfterResponsibleChange ||
															resourceRequest.responsibleBusinessUnit === bu
														"
														height="2"
													>
													</app-list-picker>
												</div>
												<div class="col-4">
													<app-list-picker
														(add)="onOfferAdd(bu)"
														(delete)="onOfferDelete($event)"
														(statusChange)="onOfferedStatusChange($event)"
														[map]="mapOffers"
														[filter]="filterColumnByValue('secondColumn', marketUnit.MarketUnit[bu])"
														[sortOff]="true"
														[possibleSelection]="offeredEmployeeStatusSelection"
														[selectionTranslate]="'mep.components.list-picker.offered-employee-status.'"
														[profilePicture]="offerFindProfilePicture"
														[originalList]="sortOfferListByStatusAndLastName(listEmitters.offers.asObservable())"
														[addButtonTooltip]="_lang('addEmployee')"
														[title]="_lang('offeredEmployees')"
														[showSkillsOfEmployee]="true"
														[disabled]="disabled || noEditingAfterResponsibleChange"
														[addKeyIconToLabel]="true"
														height="2"
													>
													</app-list-picker>
												</div>
											</div>
										</fieldset>
									</div>
								}
							</div>
						}
					</div>
				}

				@if (
					permissions.hasReadOnConfidentialFields &&
					businessUnitsOfUser &&
					!permissions.isAdmin &&
					resourceRequest &&
					!addMode
				) {
					<div class="row">
						@if (resourceRequest.businessUnits.length > 0 && checkIfUserHasInterestedBu(true)) {
							<div class="header-container">
								<h2>{{ _lang("interestedBusinessUnits") }}</h2>
							</div>
						}
						@for (bu of resourceRequest.businessUnits; track bu) {
							<div>
								@if (resourceRequest.responsibleBusinessUnit !== bu) {
									<div>
										<fieldset class="rounded p-3 mb-3 interested-bu-fieldset-row">
											<legend class="legend-interested-bu">{{ marketUnit.MarketUnit[bu] }}</legend>
											<div class="row interested-rows-as-responsible">
												<div class="col-3">
													<app-list-picker
														(add)="onInterestedResponsibleAdd(bu)"
														(delete)="onInterestedResponsibleDelete($event)"
														[map]="mapInterestedResponsible"
														[profilePicture]="offerFindProfilePicture"
														[originalList]="
															filterInterestedResponsibleListByBu(listEmitters.interestedResponsible.asObservable(), bu)
														"
														[title]="_lang('contact-persons')"
														[addButtonTooltip]="_lang('addInterestedResponsible')"
														[disabled]="disabled || noEditingAfterResponsibleChange"
														height="2"
													>
													</app-list-picker>
												</div>
												@if (businessUnitsOfUser.includes(bu)) {
													<div class="col-4">
														<app-list-picker
															(add)="onInterestedStaffingCommentAdd(bu)"
															(delete)="onInterestedStaffingCommentsDelete($event)"
															[map]="mapStaffingComments"
															[originalList]="
																filterCommentListByBu(listEmitters.interestedStaffingComments.asObservable(), bu)
															"
															[addButtonTooltip]="_lang('addStaffingComment')"
															[title]="_lang('staffingComments')"
															[addKeyIconToLabel]="true"
															[disabled]="disabled || noEditingAfterResponsibleChange"
															height="2"
														>
														</app-list-picker>
													</div>
												}
												@if (!businessUnitsOfUser.includes(bu)) {
													<div class="col-4 d-flex justify-content-center align-items-center no-comment-view">
														{{ _lang("noPermissionToViewComment") }}
													</div>
												}
												<div class="col-5">
													<app-list-picker
														(add)="onOfferAdd(bu)"
														(delete)="onOfferDelete($event)"
														(statusChange)="onOfferedStatusChange($event)"
														[map]="mapOffers"
														[filter]="filterColumnByValue('secondColumn', marketUnit.MarketUnit[bu])"
														[possibleSelection]="offeredEmployeeStatusSelection"
														[selectionTranslate]="'mep.components.list-picker.offered-employee-status.'"
														[profilePicture]="offerFindProfilePicture"
														[sortOff]="true"
														[originalList]="sortOfferListByStatusAndLastName(listEmitters.offers.asObservable())"
														[addButtonTooltip]="_lang('addEmployee')"
														[title]="_lang('offeredEmployees')"
														[showSkillsOfEmployee]="true"
														[disabled]="disabled || noEditingAfterResponsibleChange"
														height="2"
													>
													</app-list-picker>
												</div>
											</div>
										</fieldset>
									</div>
								}
							</div>
						}
					</div>
				}

				@if (resourceRequest && businessUnitsOfUser && permissions.hasInterestedBUWritePermissionsOnly) {
					<div class="row">
						@if (resourceRequest.businessUnits.length > 0 && checkIfUserHasInterestedBu()) {
							<div class="header-container">
								<h1>{{ _lang("interestedBusinessUnits") }}</h1>
							</div>
						}
						@for (bu of resourceRequest.businessUnits; track bu) {
							<div>
								@if (businessUnitsOfUser.includes(bu)) {
									<div>
										<fieldset class="rounded p-3 mb-3 interested-bu-fieldset-row">
											<legend class="legend-interested-bu">{{ marketUnit.MarketUnit[bu] }}</legend>
											<div class="row interested-rows-as-responsible">
												<div class="col-3">
													<app-list-picker
														(add)="onInterestedResponsibleAdd(bu)"
														(delete)="onInterestedResponsibleDelete($event)"
														[map]="mapInterestedResponsible"
														[profilePicture]="offerFindProfilePicture"
														[originalList]="
															filterInterestedResponsibleListByBu(listEmitters.interestedResponsible.asObservable(), bu)
														"
														[title]="_lang('contact-persons')"
														[addButtonTooltip]="_lang('addInterestedResponsible')"
														[addKeyIconToLabel]="true"
														height="2"
													>
													</app-list-picker>
												</div>
												@if (resourceRequest) {
													<div class="col-5">
														<app-list-picker
															(add)="onInterestedStaffingCommentAdd(bu)"
															(delete)="onInterestedStaffingCommentsDelete($event)"
															[map]="mapStaffingComments"
															[originalList]="
																filterCommentListByBu(listEmitters.interestedStaffingComments.asObservable(), bu)
															"
															[addButtonTooltip]="_lang('addStaffingComment')"
															[title]="_lang('staffingComments')"
															[addKeyIconToLabel]="true"
															height="2"
														>
														</app-list-picker>
													</div>
												}
												<div class="col-4">
													<app-list-picker
														(add)="onOfferAdd(bu)"
														(delete)="onOfferDelete($event)"
														(statusChange)="onOfferedStatusChange($event)"
														[map]="mapOffers"
														[filter]="filterColumnByValue('secondColumn', marketUnit.MarketUnit[bu])"
														[sortOff]="true"
														[possibleSelection]="offeredEmployeeStatusSelection"
														[selectionTranslate]="'mep.components.list-picker.offered-employee-status.'"
														[profilePicture]="offerFindProfilePicture"
														[originalList]="sortOfferListByStatusAndLastName(listEmitters.offers.asObservable())"
														[addButtonTooltip]="_lang('addEmployee')"
														[title]="_lang('offeredEmployees')"
														[showSkillsOfEmployee]="true"
														[addKeyIconToLabel]="true"
														[canChangeStatus]="false"
														height="2"
													>
													</app-list-picker>
												</div>
											</div>
										</fieldset>
									</div>
								}
							</div>
						}
					</div>
				}
			</form>
			<footer>
				<button id="stepper-prev-to-p2" mat-flat-button matStepperPrevious>
					<mat-icon class="arrows"> keyboard_arrow_left</mat-icon>
				</button>
				@if (addMode) {
					<button
						id="submit"
						class="mep-btn-big bigger-submit"
						(click)="submit()"
						[disabled]="isSubmitButtonDisabled()"
					>
						{{ getSubmitButtonLabel() }}
					</button>
				}
			</footer>
		</mat-step>
	</mat-horizontal-stepper>
</div>

<button id="nav-button-left" mat-button (click)="previousStep()">
	<mat-icon class="arrows">keyboard_arrow_left</mat-icon>
</button>

<button id="nav-button-right" mat-button (click)="nextStep()">
	<mat-icon class="arrows">keyboard_arrow_right</mat-icon>
</button>
